import type { TApiODIN } from "@/apis/odin/apiODIN";
import type { TStoreRoot } from "@/store";

export const checkIfThisIsE2ETestsEnvironment = () =>
    window.navigator.webdriver;

export const setupE2ETestsRuntimeDependencies = ({
    apiODIN,
    getState,
}: {
    apiODIN: TApiODIN;
    getState: () => TStoreRoot;
}) => {
    (window as Window & typeof globalThis & { apiODIN: TApiODIN }).apiODIN =
        apiODIN;
    (
        window as Window & typeof globalThis & { getState: () => TStoreRoot }
    ).getState = getState;
};
